import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { uploadFileThunk } from "../store/slices/fileSlice";
import { useRef } from "react";


const useFileUpload = (form, dispatch) => {
  const { loading } = useSelector((state) => state.file);
  const abortRef = useRef(null);

  const handleFileUpload = async (file) => {
    if (loading || !file) return;

    const values = form.getFieldsValue();

    const localMeta = {
      name: file.name,
      size: file.size,
    };

    try {
      const promise = dispatch(
        uploadFileThunk({
          file,
          processName: values.processName || "",
          subProcess: values.subProcess || "",
          fileName: values.fileName || file.name,
          localFileMeta: localMeta,
        })
      );
      abortRef.current = promise;

      await promise.unwrap();
      toast.success("File uploaded. Ready to submit.", { theme: "colored" });
    } catch (err) {
      if (err.name === "AbortError" || err.message === "Aborted") {
        // console.log("Request cancelled");
        return;
      }
      toast.error(err || "Upload failed!", { theme: "colored" });
    } finally {
      abortRef.current = null;
    }
  };

  const handleCancel = () => {
    if (abortRef.current) {
      abortRef.current.abort();
      abortRef.current = null;
      toast.info("Upload cancelled.", { theme: "colored" });
    }
  };


  return { handleFileUpload, handleCancel };
};

export default useFileUpload;
